export default __webpack_public_path__ + "static/media/iloilo.ba302d0a.jpg";